import { useCallback, useMemo } from 'react'
import { useRecoilState } from 'recoil'

import { ProfileSection } from '../types/profile'
import { profileSectionInEditAtom } from './atoms/profile'

type ProfileEdit = {
  edit: () => void
  cancelEdit: () => void
  isInReadOnly: boolean
  isInEdit: boolean
  isAnotherSectionInEdit: boolean
}

export const useProfileEdit = (profileSection: ProfileSection): ProfileEdit => {
  const [profileSectionInEdit, setProfileSectionInEdit] = useRecoilState(
    profileSectionInEditAtom
  )

  const edit = useCallback(() => {
    setProfileSectionInEdit(profileSection)
  }, [profileSection, setProfileSectionInEdit])

  const cancelEdit = useCallback(() => {
    setProfileSectionInEdit(null)
  }, [setProfileSectionInEdit])

  const isInEdit = useMemo(
    () => !!profileSectionInEdit && profileSectionInEdit === profileSection,
    [profileSection, profileSectionInEdit]
  )

  const isAnotherSectionInEdit = useMemo(
    () => !!profileSectionInEdit && profileSectionInEdit !== profileSection,
    [profileSection, profileSectionInEdit]
  )

  const isInReadOnly = useMemo(
    () => !isInEdit && !isAnotherSectionInEdit,
    [isInEdit, isAnotherSectionInEdit]
  )

  return {
    edit,
    cancelEdit,
    isInReadOnly,
    isInEdit,
    isAnotherSectionInEdit,
  }
}
